// extracted by mini-css-extract-plugin
module.exports = {"description":"life-at-v2-carousel_description__HV4bq"};